import { render, staticRenderFns } from "./CreateSplashScreenVideoModal.vue?vue&type=template&id=2482645d&scoped=true"
import script from "./CreateSplashScreenVideoModal.vue?vue&type=script&lang=js"
export * from "./CreateSplashScreenVideoModal.vue?vue&type=script&lang=js"
import style0 from "./CreateSplashScreenVideoModal.vue?vue&type=style&index=0&id=2482645d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2482645d",
  null
  
)

export default component.exports